The details of the deleted position opening.
